/* istanbul ignore file */
import { array as codecArray, string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const AssistantModelsSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('ASSISTANT_MODELS')],
    [
        'value',
        /* #__PURE__ */ parsers.maybeNull(/* #__PURE__ */ codecArray(codecString)),
    ],
]);
export class AssistantModelsSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return AssistantModelsSettingParser.decode(input).map(res => new AssistantModelsSetting(res));
    }
    static unsafeDecode(input) {
        return AssistantModelsSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return AssistantModelsSettingParser.encode(data);
    }
    static schema() {
        return AssistantModelsSettingParser.schema();
    }
}
